import moment from 'moment';
import { Options, Vue } from 'vue-class-component';
import EoiWording from '../../assets/config/eoi-wording.json';

@Options({
  props: {
    committeeYear: String
  }
})
export default class Confirmation extends Vue {
  committeeYear!: string

  get pageHeader(): string {
    return EoiWording[0].confirmation['pageHeader']
  }

  get pageBody(): string {
    let htmlText = EoiWording[0].confirmation['pageBody'].replace('-{{YYYY}}-', this.committeeYear);
    htmlText = htmlText.replace('-{{DD Month YYYY}}-', moment(this.committeeYear).format('DD MMM YYYY').toUpperCase());
    return htmlText;
  }
}
